export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    slug: 'xuexi-jiaoyu',
    name: '学习教育',
    description: '汇聚海量学习资料、在线课程、考试题库，助您高效提升知识储备',
    icon: 'ri-book-open-line',
    articleCount: 1256,
  },
  {
    slug: 'yingshi-yule',
    name: '影视娱乐',
    description: '热门电影、电视剧、综艺节目、动漫资源，一网打尽精彩内容',
    icon: 'ri-movie-2-line',
    articleCount: 3421,
  },
  {
    slug: 'ruanjian-gongju',
    name: '软件工具',
    description: '实用软件、效率工具、开发者资源，让工作学习事半功倍',
    icon: 'ri-terminal-box-line',
    articleCount: 2890,
  },
  {
    slug: 'sheji-sucai',
    name: '设计素材',
    description: '高质量设计模板、图标、字体、图片素材，满足创意需求',
    icon: 'ri-palette-line',
    articleCount: 1876,
  },
  {
    slug: 'yinyue-yinpin',
    name: '音乐音频',
    description: '无损音乐、播客节目、音效素材，畅享听觉盛宴',
    icon: 'ri-music-2-line',
    articleCount: 953,
  },
  {
    slug: 'tushu-wenxian',
    name: '图书文献',
    description: '电子书籍、学术论文、行业报告，知识海洋任您遨游',
    icon: 'ri-book-3-line',
    articleCount: 2103,
  },
  {
    slug: 'youxi-ziyuan',
    name: '游戏资源',
    description: '热门游戏攻略、MOD资源、游戏资讯，玩转游戏世界',
    icon: 'ri-gamepad-line',
    articleCount: 1567,
  },
  {
    slug: 'shenghuo-baike',
    name: '生活百科',
    description: '美食菜谱、旅行攻略、健康养生，让生活更加丰富多彩',
    icon: 'ri-heart-pulse-line',
    articleCount: 1145,
  },
];